import { Deserializable } from '../deserializable';

export class EmailWrapperDto implements Deserializable {
  public Email: string;
  public InterfaceTypeId?: number;
  public PropositionId?: number;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
